module.exports = __webpack_public_path__ + "static/comply_advantage.66218dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/sections/content/partners/comply_advantage.png
// module id = 507
// module chunks = 35783957827783